<template>
  <button
    type="button"
    class="sw-event"
    :class="{ 'is-blocked': blocked, 'has-marker': markerColor }"
    :style="accentStyle"
    :title="detailTitle"
    @click.stop="$emit('open', schedule)"
  >
    <span class="sw-event__time">{{ time }}</span>
    <span
      v-if="!blocked"
      class="sw-event__kind"
      :class="{ 'is-exam': isExam }"
    >{{ isExam ? 'E' : 'C' }}</span>
    <span class="sw-event__name">{{ label }}</span>
  </button>
</template>

<script>
import moment from '../../../helpers/date';
import { BLOCKED_SCHEDULE_COLOR, blockedTimeRangeLabel, isBlockedSchedule } from '../../../helpers/scheduleDay';

export default {
  name: 'ScheduleAgendaItem',
  props: {
    schedule: { type: Object, required: true },
  },
  emits: ['open'],
  computed: {
    blocked() {
      return isBlockedSchedule(this.schedule);
    },
    time() {
      if (this.blocked) return blockedTimeRangeLabel(this.schedule);
      if (this.schedule.sched_time) return this.schedule.sched_time;
      const raw = this.schedule.schedule_date_time;
      return raw ? moment(raw).format('HH:mm') : '';
    },
    label() {
      if (this.blocked) {
        return this.schedule.patient_name ? `Bloqueado · ${this.schedule.patient_name}` : 'Bloqueado';
      }
      return this.schedule.patient_name || 'Agendamento';
    },
    isExam() {
      return Boolean(this.schedule.kind_exam);
    },
    detailTitle() {
      if (this.blocked) return this.label;
      return [
        this.isExam ? 'E' : 'C',
        this.schedule.patient_name,
        this.schedule.sched_online ? 'Online' : '',
        this.schedule.spec_name,
        this.schedule.paymeth_name,
        this.schedule.insurance_name,
      ].filter(Boolean).join(' | ');
    },
    accentStyle() {
      const color = this.schedule.sched_status_color || (this.blocked ? BLOCKED_SCHEDULE_COLOR : '#780f5a');
      const style = { borderLeftColor: color };
      if (this.markerColor) style.borderBottomColor = this.markerColor;
      return style;
    },
    markerColor() {
      const color = String(this.schedule.ps_color || '').trim();
      if (!color) return '';
      if (['#000', '#000000', 'black', '#00000000'].includes(color.toLowerCase())) return '';
      return color;
    },
  },
};
</script>

<style scoped>
.sw-event {
  display: flex;
  align-items: baseline;
  gap: 0.35rem;
  width: 100%;
  margin: 0 0 0.28rem;
  padding: 0.28rem 0.4rem;
  border: 0;
  border-left: 3px solid #780f5a;
  border-radius: 0.35rem;
  background: #fff;
  color: #181c32;
  text-align: left;
  cursor: pointer;
  box-shadow: 0 0 0 1px #eef0f8;
}
.sw-event:hover {
  background: #f8f5f7;
}
.sw-event.has-marker {
  border-bottom: 3px solid #e4e6ef;
}
.sw-event.is-blocked {
  background: #f6e8fb;
  color: #7b16b5;
}
.sw-event__time {
  flex-shrink: 0;
  font-size: 0.76rem;
  font-weight: 700;
  color: #7e8299;
}
.sw-event.is-blocked .sw-event__time {
  color: #8b2fc9;
}
.sw-event__kind {
  flex-shrink: 0;
  width: 1rem;
  height: 1rem;
  border-radius: 0.2rem;
  background: #f1faff;
  color: #009ef7;
  font-size: 0.58rem;
  font-weight: 800;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.sw-event__kind.is-exam {
  background: #fff8dd;
  color: #c27803;
}
.sw-event__name {
  min-width: 0;
  font-size: 0.82rem;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
